module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "400",
      "persistent": ""
    },
    model: {
      value: (_vm.showDlg),
      callback: function($$v) {
        _vm.showDlg = $$v
      },
      expression: "showDlg"
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.loginToApp($event)
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    ref: "refMob",
    attrs: {
      "label": "",
      "placeholder": "Enter a mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      }
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace($event)
      }
    },
    model: {
      value: (_vm.mobile),
      callback: function($$v) {
        _vm.mobile = $$v
      },
      expression: "mobile"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("\n                    Enter your mobile number and press send OTP\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('span', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.canResend) ? _c('v-flex', {
    attrs: {
      "xs1": ""
    },
    on: {
      "click": function($event) {
        _vm.isOTPSent = false
      }
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-2",
    model: {
      value: (_vm.reqOTPToMobile),
      callback: function($$v) {
        _vm.reqOTPToMobile = $$v
      },
      expression: "reqOTPToMobile"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.secToWait > 0) ? _c('v-flex', {
    staticClass: "mt-3 text-xs-right",
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Wait " + _vm._s(_vm.secToWait) + " sec to retry")])]) : (_vm.canResend || _vm.reqOTPToMobile) ? _c('v-flex', {
    staticClass: "mt-3 text-xs-left",
    attrs: {
      "xs7": ""
    },
    on: {
      "click": function($event) {
        _vm.isOTPSent = false;
        _vm.reqOTPToMobile = !_vm.reqOTPToMobile
      }
    }
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("Send OTP to mobile as well")])]) : _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0 pa-0 accent--text",
    attrs: {
      "flat": "",
      "disabled": (!_vm.canResend && !_vm.isValidNumber) || _vm.secToWait > 0
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("\n                          " + _vm._s((_vm.canResend ? 'Resend' : 'Send') + ' OTP') + "\n                        ")])], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "caption pa-2 mt-0",
    attrs: {
      "value": "true",
      "color": "info"
    }
  }, [(_vm.reqOTPToMobile) ? _c('span', [_vm._v("OTP is sent to your mobile & email. Please check and enter here")]) : _c('span', [_vm._v("OTP is sent to your email " + _vm._s(_vm.OTPRes.contact_email) + ". Please check (including spam folder) and enter here")])])], 1) : _vm._e(), _vm._v(" "), (_vm.isOTPSent) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP"
    },
    model: {
      value: (_vm.otp),
      callback: function($$v) {
        _vm.otp = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "otp"
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "primary"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeDlg($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right accent--text",
    attrs: {
      "flat": "",
      "type": "submit",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Log in")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-03217ce4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 715
// module chunks = 29